// extracted by mini-css-extract-plugin
export var infoItem = "_tg-2";
export var title = "_tg-0";
export var value = "_tg-1";